import { createSlice } from "@reduxjs/toolkit";
import { resetStore } from "app/actions";
import { RootState } from "app/store";
import { emitSound } from "app/thunks/soundsAPI";

export enum SOUNDS {
  DONT_RUN = "DONT_RUN",
  OPERATOR_IN_COMING = "OPERATOR_IN_COMING",
  HANDS_ON_GUN = "HANDS_ON_GUN",
}

export interface State {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  error: any;
}

const initialState: State = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: undefined,
};

export const soundsSlice = createSlice({
  name: "sounds",
  initialState,
  reducers: {
    resetFlags: (state) => {
      state.isSuccess = false;
      state.isLoading = false;
      state.isError = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetStore, () => initialState)
      .addCase(emitSound.pending, (state) => {
        state.isSuccess = false;
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(emitSound.rejected, (state, action) => {
        state.isSuccess = false;
        state.isLoading = false;
        state.isError = true;
        state.error = action.payload;
      })
      .addCase(emitSound.fulfilled, (state) => {
        state.isSuccess = true;
        state.isLoading = false;
        state.isError = false;
      });
  },
});

export const { resetFlags } = soundsSlice.actions;

// ------ Selectors ------

export const getSoundsActionState = (state: RootState) => ({
  isLoading: state.sounds.isLoading,
  isSuccess: state.sounds.isSuccess,
  isError: state.sounds.isError,
  error: state.sounds.error,
});

export default soundsSlice.reducer;
